module.exports = "/static/assets/ee391d4556c47170aa89072b88669350.png";